function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
// If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));

// ../../../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js
var require_lodash = __commonJS({
  "../../../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js"(exports, module) {
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var asyncTag = "[object AsyncFunction]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var nullTag = "[object Null]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var proxyTag = "[object Proxy]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var undefinedTag = "[object Undefined]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function () {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {}
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var nativeObjectToString = objectProto.toString;
    var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var Symbol2 = root.Symbol;
    var Uint8Array2 = root.Uint8Array;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var splice = arrayProto.splice;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var nativeKeys = overArg(Object.keys, Object);
    var DataView = getNative(root, "DataView");
    var Map = getNative(root, "Map");
    var Promise2 = getNative(root, "Promise");
    var Set = getNative(root, "Set");
    var WeakMap = getNative(root, "WeakMap");
    var nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set);
    var weakMapCtorString = toSource(WeakMap);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function Hash(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
        size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values) {
      var index = -1,
        length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key) {
      var data = this.__data__,
        result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == "length" ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") ||
        // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index < arrLength) {
        var arrValue = array[index],
          othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function (othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
          othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
          othCtor = other.constructor;
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function (value) {
        var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : void 0,
          ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + "";
        } catch (e) {}
      }
      return "";
    }
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArguments = baseIsArguments(/* @__PURE__ */function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isEqual2(value, other) {
      return baseIsEqual(value, other);
    }
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function stubArray() {
      return [];
    }
    function stubFalse() {
      return false;
    }
    module.exports = isEqual2;
  }
});

// src/components/contact-us-widget/contact-us.tsx
import React45 from "react";
import { ChatContainer, ChatContainerContent, ChatContainerHeader } from "@egds/react-virtual-agent-control";
import { gql as gql26, useQuery as useQuery2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { VirtualAgentControl } from "@shared-ui/customer-virtual-agent-control";

// ../internal/src/components/egds-loader/egds-loader.tsx
import React from "react";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLoader } from "@egds/react-core/loader";
var CenteredLoader = props => {
  const {
    blockSize = "full_size",
    loaderProps
  } = props;
  return /* @__PURE__ */React.createElement(EGDSLayoutGrid, {
    blockSize
  }, /* @__PURE__ */React.createElement(EGDSLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      top: "center",
      left: "center"
    },
    cloneElement: true
  }, /* @__PURE__ */React.createElement(EGDSLoader, __spreadValues({}, loaderProps))))));
};

// src/components/contact-us-widget/contact-us.tsx
import { ContactUsStateEvent as ContactUsStateEvent5, REQUIRED_EVENT as REQUIRED_EVENT2, useContactUsState as useContactUsState5 } from "@shared-ui/retail-help-center-util";

// src/components/contact-us-widget/components/floating-action-button.tsx
import React5 from "react";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-button/egds-button.tsx
import React4 from "react";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React2 from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    title
    theme
    spotLight
  }
`;
var mapSpotlight = spotlight => {
  if (!spotlight) {
    return void 0;
  }
  switch (spotlight) {
    case "STANDARD" /* STANDARD */:
      return "standard";
    case "POSITIVE" /* POSITIVE */:
      return "positive";
    case "WARNING" /* WARNING */:
      return "warning";
    case "INFO" /* INFO */:
      return "info";
    default:
      return void 0;
  }
};
var HelpCenterEGDSIcon = ({
  data,
  size
}) => {
  var _a, _b;
  const iconName = data ? data.id : "";
  const finalSize = size != null ? size : (data == null ? void 0 : data.size) && EGDSIconSize[data.size];
  const spotlight = data == null ? void 0 : data.spotLight;
  const title = (_a = data == null ? void 0 : data.title) != null ? _a : void 0;
  return /* @__PURE__ */React2.createElement(EGDSIcon, {
    id: iconName,
    name: iconName,
    size: finalSize,
    title,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    spotlight: mapSpotlight(spotlight)
  });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React3 from "react";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql2`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }
  }

  ${HelpCenterEGDSIcon.fragment}
`;
var EGDSGraphic = ({
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-button/egds-button.tsx
var __fragment = gql3`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    disabled
    icon {
      ...EGDSIconFragment
    }
    accessibility
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSButton = _a => {
  var _b = _a,
    {
      data,
      onClickHandler,
      isDisabled,
      type,
      iconPosition = "LEADING" /* LEADING */
    } = _b,
    otherProps = __objRest(_b, ["data", "onClickHandler", "isDisabled", "type", "iconPosition"]);
  const {
    primary,
    disabled,
    accessibility,
    __typename,
    icon
  } = data;
  const buttonProps = {
    disabled: disabled || isDisabled,
    title: accessibility,
    type,
    onClick: onClickHandler
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React4.createElement(EGDSPrimaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UISecondaryButton":
      return /* @__PURE__ */React4.createElement(EGDSSecondaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UITertiaryButton":
      return /* @__PURE__ */React4.createElement(EGDSTertiaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    default:
      return null;
  }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment;

// src/components/contact-us-widget/components/floating-action-button.tsx
var fragment = gql4`
  fragment FloatingActionButtonFragment on UISecondaryFloatingActionButton {
    disabled
    primary
    icon {
      ...EGDSIconFragment
    }
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var FloatingActionButton = ({
  onClick,
  unreadMessageCount,
  data
}) => {
  const {
    disabled,
    icon,
    primary
  } = data;
  return /* @__PURE__ */React5.createElement(EGDSLayoutPosition2, {
    type: "fixed",
    position: {
      bottom: "four",
      right: "four"
    }
  }, /* @__PURE__ */React5.createElement(HelpCenterEGDSButton, {
    data: {
      primary,
      disabled,
      accessibility: primary,
      __typename: "UISecondaryButton",
      icon
    },
    isFullWidth: true,
    "data-stid": "fabButton",
    onClickHandler: onClick
  }));
};
FloatingActionButton.fragment = fragment;
FloatingActionButton.displayName = "ContactUsFloatingActionButton";

// src/components/contact-us-widget/components/tool-bar.tsx
import React6 from "react";
import { EGDSToolbar, EGDSToolbarButton } from "@egds/react-core/toolbar";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
import { ContactUsStateEvent, ContactUsViewType, useContactUsState } from "@shared-ui/retail-help-center-util";
var fragment2 = gql5`
  fragment ContactUsToolBarFragmentV2 on ContactUsToolBarV2 {
    title
    closeIcon {
      ...EGDSIconFragment
    }
    vaIcon {
      ...EGDSIconFragment
    }
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var ContactUsToolBarV2 = ({
  data
}) => {
  const {
    title,
    closeIcon,
    vaIcon
  } = data;
  const [contactUsState, contactUsStateDispatch] = useContactUsState();
  return /* @__PURE__ */React6.createElement(EGDSToolbar, {
    navigationContent: {
      navIconLabel: closeIcon.id,
      navButtonId: closeIcon.id,
      onClick: () => contactUsStateDispatch({
        type: ContactUsStateEvent.CLOSE_WIDGET
      })
    },
    toolbarTitle: title,
    toolbarActionContent: /* @__PURE__ */React6.createElement(EGDSToolbarButton, {
      buttonId: vaIcon.id,
      onClick: () => contactUsStateDispatch({
        type: ContactUsStateEvent.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType.VIRTUAL_AGENT
        }
      })
    }, /* @__PURE__ */React6.createElement(HelpCenterEGDSIcon, {
      data: vaIcon
    })),
    toolbarTitleA11yText: title
  });
};
ContactUsToolBarV2.fragment = fragment2;
ContactUsToolBarV2.displayName = "ContactUsToolBarV2";

// src/__generated__/types.ts
var ContactUsViewType2 = /* @__PURE__ */(ContactUsViewType6 => {
  ContactUsViewType6["CHAT_OPTIONS"] = "CHAT_OPTIONS";
  ContactUsViewType6["CONTACT_OPTIONS"] = "CONTACT_OPTIONS";
  ContactUsViewType6["LANDING_PAGE"] = "LANDING_PAGE";
  ContactUsViewType6["VIRTUAL_AGENT"] = "VIRTUAL_AGENT";
  ContactUsViewType6["VOICE_OPTIONS"] = "VOICE_OPTIONS";
  return ContactUsViewType6;
})(ContactUsViewType2 || {});

// src/components/contact-us-view/contact-us-view.tsx
import React44, { useState as useState3 } from "react";
import { gql as gql25, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";

// src/components/contact-us-view/components/contact-us-heading.tsx
import React34 from "react";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-text.tsx
import React32 from "react";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-heading.tsx
import React7 from "react";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var fragment3 = gql6`
  fragment EGDSHeadingFragment on EGDSHeading {
    headingType
    text
  }
`;
var EGDSHeadingStyleMap = {
  ["H1" /* H1 */]: "h1",
  ["H2" /* H2 */]: "h2",
  ["H3" /* H3 */]: "h3",
  ["H4" /* H4 */]: "h4",
  ["H5" /* H5 */]: "h5",
  ["H6" /* H6 */]: "h6",
  ["H7" /* H7 */]: "h6",
  ["H8" /* H8 */]: "h6"
};
var EGDSHeadingSizeMap = {
  ["H1" /* H1 */]: 3,
  ["H2" /* H2 */]: 4,
  ["H3" /* H3 */]: 5,
  ["H4" /* H4 */]: 6,
  ["H5" /* H5 */]: 7,
  ["H6" /* H6 */]: 8,
  ["H7" /* H7 */]: 8,
  ["H8" /* H8 */]: 8
};
var HelpCenterEGDSHeading = ({
  data,
  size,
  margin,
  padding
}) => {
  const tag = data.headingType !== null ? EGDSHeadingStyleMap[data.headingType] : void 0;
  const headingSize = size != null ? size : data.headingType == null ? void 0 : EGDSHeadingSizeMap[data.headingType];
  const marginSize = margin != null ? margin : {
    blockstart: "two"
  };
  const paddingSize = padding != null ? padding : void 0;
  return /* @__PURE__ */React7.createElement(EGDSSpacing, {
    margin: marginSize,
    padding: paddingSize
  }, /* @__PURE__ */React7.createElement(EGDSHeading, {
    tag,
    size: headingSize
  }, data.text));
};
HelpCenterEGDSHeading.fragment = fragment3;
HelpCenterEGDSHeading.displayName = "HelpCenterEGDSHeading";

// ../internal/src/components/egds-text/egds-paragraph.tsx
import React8 from "react";
import { EGDSParagraph } from "@egds/react-core/text";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
var fragment4 = gql7`
  fragment EGDSParagraphFragment on EGDSParagraph {
    text
    style
  }
`;
var EGDSParagraphSizeMap = {
  ["P1" /* P1 */]: 1,
  ["P2" /* P2 */]: 2,
  ["P3" /* P3 */]: 3
};
var HelpCenterEGDSParagraph = ({
  data
}) => {
  return /* @__PURE__ */React8.createElement(EGDSParagraph, {
    size: EGDSParagraphSizeMap[data.style]
  }, data.text);
};
HelpCenterEGDSParagraph.fragment = fragment4;
HelpCenterEGDSParagraph.displayName = "HelpCenterEGDSParagraph";

// ../internal/src/components/egds-text/egds-plain-text.tsx
import React9 from "react";
import { EGDSText } from "@egds/react-core/text";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";
var fragment5 = gql8`
  fragment EGDSPlainTextFragment on EGDSPlainText {
    text
  }
`;
var EGDSPlainText = ({
  data,
  align,
  inline,
  size
}) => /* @__PURE__ */React9.createElement(EGDSText, {
  align,
  inline,
  size,
  spacing: "two"
}, data.text);
EGDSPlainText.fragment = fragment5;
EGDSPlainText.displayName = "EGDSPlainText";

// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React31 from "react";
import { EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-inline-link.tsx
import React29 from "react";
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";

// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@18.3.1/node_modules/@shared-ui/experiment-context/dist/esmodule/experiment-context.js
import * as React10 from "react";
var defaults = {
  getExposure: function (name) {
    return null;
  },
  logExperiment: function (exposure) {
    return void 0;
  }
};
var ExperimentContext = React10.createContext(defaults);

// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@18.3.1/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment-control.js
import * as React11 from "react";
var ExperimentControl = function (props) {
  return React11.createElement(React11.Fragment, null, props.children || null);
};

// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@18.3.1/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment-variant.js
import * as React12 from "react";
var ExperimentVariant = function (props) {
  return React12.createElement(React12.Fragment, null, props.children || null);
};

// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@18.3.1/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment.js
import * as React13 from "react";
import { useContext, useEffect } from "react";
var Experiment = function (_a) {
  var name = _a.name,
    children = _a.children,
    _b = _a.logExposure,
    logExposure = _b === void 0 ? true : _b;
  var _c = useContext(ExperimentContext),
    getExposure = _c.getExposure,
    logExperiment = _c.logExperiment;
  var exposure;
  if (name) {
    exposure = getExposure(name);
  }
  var bucket = (exposure === null || exposure === void 0 ? void 0 : exposure.bucket) || 0;
  var control;
  var matchedComponent = children.find(function (child) {
    if (child.type === ExperimentControl) {
      control = child;
      if (bucket === 0) {
        return true;
      }
    }
    return child.props.bucket === bucket;
  });
  if (!matchedComponent || matchedComponent === -1) {
    if (control) {
      return React13.Children.only(control);
    }
    return null;
  }
  if (exposure && logExposure) {
    try {
      logExperiment(exposure);
    } catch (e) {}
  }
  return React13.Children.only(matchedComponent);
};
var useExperiment = function (name, shouldLogExperiment) {
  var _a;
  var _b = useContext(ExperimentContext),
    getExposure = _b.getExposure,
    logExperiment = _b.logExperiment;
  var exposure = (_a = getExposure(name)) !== null && _a !== void 0 ? _a : {
    name,
    bucket: 0
  };
  useEffect(function () {
    if (exposure && shouldLogExperiment) {
      try {
        logExperiment(exposure);
      } catch (e) {}
    }
  }, [logExperiment]);
  return {
    exposure,
    logExperiment
  };
};

// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@18.3.1/node_modules/@shared-ui/experiment-context/dist/esmodule/components/mock-experiment-provider.js
import * as React14 from "react";

// ../internal/src/components/egds-text/egds-inline-link-control.tsx
import React27, { useCallback as useCallback4 } from "react";
import { EGDSLink } from "@egds/react-core/link";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/utils/constants.ts
var EVENT_TYPE = "Interaction";
var EVENT_CATEGORY = "help_center";
var EVENT_VERSION = "1.2.0";
var PAGE_NAME = "Help Articles";
var PAGE_NAME_DETAILED = "Help Articles";
var APP_NAME = "ecp-help-center";
var APP_VERSION = "1.0.0";
var ARTICLE_DIALOG = "article_dialog";
var EVENT_NAME = "help_article_link.selected";
var CONTACT_US_ARTICLE_LINK_TYPE = "Contact Us";
var ARTICLE_GROUP_FROM_SEARCH_BAR = "search";
var ARTICLE_GROUP_FROM_EXTERNAL_LINK = "From External";

// ../help-articles/src/utils/eg-clickstream-helper.ts
var buildClickstreamAnalyticsForExternalArticles = (articleLink, articleLinkType, articleName, articleGroup, searchTerm) => {
  return {
    event: {
      event_name: EVENT_NAME,
      event_version: EVENT_VERSION,
      event_type: EVENT_TYPE,
      event_category: EVENT_CATEGORY,
      action_location: ARTICLE_DIALOG
    },
    article: {
      article_name: articleName,
      article_group: articleGroup,
      article_link: articleLink,
      article_link_type: articleLinkType,
      search_term: searchTerm
    },
    experience: {
      page_name: PAGE_NAME,
      app_name: APP_NAME,
      app_version: APP_VERSION,
      page_name_detailed: PAGE_NAME_DETAILED
    }
  };
};
var getArticleGroup = articleInfo => {
  const {
    product,
    searchTerm
  } = articleInfo;
  if (!product && searchTerm) {
    return ARTICLE_GROUP_FROM_SEARCH_BAR;
  }
  if (!product && !searchTerm) {
    return ARTICLE_GROUP_FROM_EXTERNAL_LINK;
  }
  return product || "";
};

// ../help-articles/src/components/help-articles/context/article-context.tsx
var import_lodash = __toESM(require_lodash());
import React20, { createContext as createContext6, useContext as useContext5, useState } from "react";

// ../../../../node_modules/.pnpm/@shared-ui+dialog-context@2.4.1_react@18.3.1/node_modules/@shared-ui/dialog-context/dist/esmodule/dialog-control.js
import * as React16 from "react";

// ../../../../node_modules/.pnpm/@shared-ui+dialog-context@2.4.1_react@18.3.1/node_modules/@shared-ui/dialog-context/dist/esmodule/dialog-state.js
import * as React15 from "react";
var DialogStateContext = React15.createContext({
  openedDialogs: [],
  open: function () {},
  close: function () {}
});

// ../../../../node_modules/.pnpm/@shared-ui+dialog-context@2.4.1_react@18.3.1/node_modules/@shared-ui/dialog-context/dist/esmodule/dialog-control.js
var defaultComponentFactory = function (isOpen) {
  return function (props) {
    return React16.createElement(React16.Fragment, null, isOpen && props.children);
  };
};
var defaults2 = {
  useDialogControl: function (id, dialogQueryKey, isOpen, setIsOpen) {
    return {
      ComponentFactory: defaultComponentFactory(isOpen),
      actions: {
        openDialog: function (options) {
          return setIsOpen(true, options === null || options === void 0 ? void 0 : options.closeAllDialogs);
        },
        closeDialog: function (options) {
          return setIsOpen(false, options === null || options === void 0 ? void 0 : options.closeAllDialogs);
        },
        toggleDialog: function (options) {
          return setIsOpen(!isOpen, options === null || options === void 0 ? void 0 : options.closeAllDialogs);
        }
      }
    };
  }
};
var DialogControlContext = React16.createContext(defaults2);

// ../../../../node_modules/.pnpm/@shared-ui+dialog-context@2.4.1_react@18.3.1/node_modules/@shared-ui/dialog-context/dist/esmodule/use-dialog.js
import * as React17 from "react";

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
import * as React18 from "react";

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/components/system-event.js
var SystemEventLevel;
(function (SystemEventLevel2) {
  SystemEventLevel2["CRITICAL"] = "CRITICAL";
  SystemEventLevel2["ERROR"] = "ERROR";
  SystemEventLevel2["WARN"] = "WARN";
  SystemEventLevel2["INFO"] = "INFO";
  SystemEventLevel2["UNKNOWN"] = "UNKNOWN";
})(SystemEventLevel || (SystemEventLevel = {}));
var SystemEvent = /** @class */
function () {
  function SystemEvent2(level, name) {
    this.level = level;
    this.name = name;
  }
  SystemEvent2.prototype.toString = function () {
    return "SystemEvent(level=" + this.level.toString() + " name=" + this.name + ")";
  };
  return SystemEvent2;
}();

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/components/logger.js
var __read = function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = function () {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
  return ar;
};
var Logger = /** @class */
/* @__PURE__ */function () {
  function Logger2(logger) {
    var _this = this;
    this.event = logger.event || function () {};
    var logAtLevel = function (level, message) {
      var args = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
      }
      if (_this.event) {
        _this.event.apply(_this, __spread([new SystemEvent(level, message)], args));
      }
    };
    this.info = logger.info || function (message) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      return logAtLevel.apply(void 0, __spread([SystemEventLevel.INFO, message], args));
    };
    this.warning = logger.warning || function (message) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      return logAtLevel.apply(void 0, __spread([SystemEventLevel.WARN, message], args));
    };
    this.error = logger.error || function (message) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      return logAtLevel.apply(void 0, __spread([SystemEventLevel.ERROR, message], args));
    };
  }
  return Logger2;
}();

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
var defaults3 = new Logger({});
var LoggerContext = React18.createContext(defaults3);
var LoggerProvider = function (props) {
  var logger = props.logger,
    children = props.children;
  var value = logger ? new Logger(logger) : defaults3;
  return React18.createElement(LoggerContext.Provider, {
    value
  }, children || null);
};
LoggerProvider.displayName = "LoggerProvider";

// ../internal/src/utils/logger-events.ts
var EVENTS = {
  HELP_ARTICLE_FEEDBACK_SUBMIT: new SystemEvent(SystemEventLevel.INFO, "HELP_ARTICLE_FEEDBACK_SUBMIT")
};

// ../help-articles/src/utils/logger-events.ts
var EVENTS2 = {
  CLICK_MORE_LINK_INFO: new SystemEvent(SystemEventLevel.INFO, "CLICKED_MORE_LINK_INFO"),
  CLICK_ARTICLE_LINK_INFO: new SystemEvent(SystemEventLevel.INFO, "CLICKED_ARTICLE_LINK_INFO"),
  ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ARTICLE_DATA_LOADING_ERROR"),
  ARTICLE_LOG_INFO: new SystemEvent(SystemEventLevel.INFO, "ARTICLE_LOG_INFO"),
  MORE_ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "MORE_ARTICLE_DATA_LOADING_ERROR"),
  SEARCH_ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "SEARCH_ARTICLE_DATA_LOADING_ERROR"),
  SEARCH_ARTICLE_WARN: new SystemEvent(SystemEventLevel.WARN, "SEARCH_ARTICLE_WARN"),
  ALL_ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ALL_ARTICLE_DATA_LOADING_ERROR"),
  TYPEAHEAD_SUGGESTION_INFO: new SystemEvent(SystemEventLevel.INFO, "TYPEAHEAD_SUGGESTION_INFO"),
  HELP_ARTICLE_FEEDBACK_SUBMIT: new SystemEvent(SystemEventLevel.INFO, "HELP_ARTICLE_FEEDBACK_SUBMIT"),
  HELP_ARTICLE_FEEDBACK_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "HELP_ARTICLE_FEEDBACK_LOADING_ERROR")
};

// ../help-articles/src/components/help-articles/context/caller-context.tsx
import { createContext as createContext5, useContext as useContext4 } from "react";
var defaultCallerContextValue = {
  callerContext: 0 /* HELP_CENTER */,
  callerContextCallback: () => {
    console.error("caller context's handler not set");
  }
};
var CallerContext = createContext5(defaultCallerContextValue);
var useCallerContext = () => useContext4(CallerContext);

// ../help-articles/src/components/help-articles/context/article-context.tsx
var defaultArticleContextValue = {
  triggerRef: null,
  setTriggerRef: () => {
    console.error("Current button`s ref not set!");
  },
  articleIdentifier: {},
  setArticleIdentifier: () => {
    console.error("Article Search callback not set!!");
  },
  isArticleDialogOpen: false,
  actionLocation: "",
  articleDialogActions: {
    openDialog: () => console.error("Article Dialog not yet initialized"),
    closeDialog: () => console.error("Article Dialog not yet initialized"),
    toggleDialog: () => console.error("Article Dialog not yet initialized")
  },
  ArticleDialogComponent: (/* istanbul ignore next -- @preserve */
  () => null),
  previousArticleId: "",
  setPreviousArticleId: () => {
    console.error("Previous article id not set!!");
  },
  preFillContactUsForm: {
    phoneNumber: "",
    itineraryNumber: "",
    category: "",
    intent: ""
  },
  setPreFillContactUsForm: () => {
    console.error("Pre fill contact us form not set!!");
  },
  articleLink: "",
  isContactUsDialogOpen: false,
  contactUsDialogActions: {
    openDialog: () => console.error("Contact us Dialog not yet initialized"),
    closeDialog: () => console.error("Contact us Dialog not yet initialized"),
    toggleDialog: () => console.error("Contact us Dialog not yet initialized")
  },
  ContactUsDialogComponent: (/* istanbul ignore next -- @preserve */
  () => null),
  shouldShowSideSheet: false,
  setShouldShowSideSheet: () => {
    console.error("shouldShowSideSheet not set!!");
  }
};
var ArticleContext = createContext6(defaultArticleContextValue);
var useArticle = () => useContext5(ArticleContext);

// ../help-articles/src/components/help-articles/context/help-articles-query-param-context.tsx
import React21 from "react";
var HelpArticleURLQueryParamsContext = React21.createContext({
  articleId: "",
  product: "",
  isCategory: false
});

// ../util/src/virtual-agent/context.tsx
import React25, { createContext as createContext8, useCallback as useCallback3, useContext as useContext7, useEffect as useEffect2, useMemo as useMemo2, useState as useState2 } from "react";
import { openChatWidget, setVacFrameVisibilityHidden } from "@shared-ui/customer-virtual-agent-control";

// ../util/src/contact-us-widget/state-provider/contact-us-state-provider.tsx
import React23 from "react";

// ../../../../node_modules/.pnpm/@shared-ui+provided-state-context@1.1.3_react@18.3.1/node_modules/@shared-ui/provided-state-context/dist/esmodule/provided-state-context.js
import * as React22 from "react";
import { useReducer as useReducer2 } from "react";
var __assign = function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read2 = function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var defaults4 = {
  state: {},
  dispatch: function () {}
};
var Context = React22.createContext(defaults4);
var buildStateProvider = function () {
  var states = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    states[_i] = arguments[_i];
  }
  var dispatchTable = {};
  var mergedState = {};
  var providedState;
  states.forEach(function (chunk) {
    var _a;
    chunk.events.forEach(function (event) {
      if (dispatchTable[event] === void 0) {
        dispatchTable[event] = [];
      }
      dispatchTable[event].push({
        callback: chunk.update,
        stateKey: chunk.stateFieldName
      });
    });
    if (mergedState[chunk.stateFieldName] !== void 0) {
      throw "buildStateProvider: Duplicate stateFieldName=".concat(chunk.stateFieldName, " defined in list of StateChunks");
    }
    mergedState = __assign(__assign({}, mergedState), (_a = {}, _a[chunk.stateFieldName] = chunk.data, _a));
  });
  providedState = {
    reducer: function (currentState, action) {
      var contexts = dispatchTable[action.type];
      if (!contexts) {
        return currentState;
      }
      var newState = __assign({}, currentState);
      contexts.forEach(function (ctx) {
        newState[ctx.stateKey] = ctx.callback(action.type, currentState[ctx.stateKey], {
          data: action.payload
        });
      });
      return newState;
    },
    state: mergedState
  };
  var StateProvider = function (props) {
    var children = props.children;
    var _a = __read2(useReducer2(providedState.reducer, providedState.state), 2),
      state = _a[0],
      dispatch = _a[1];
    return React22.createElement(Context.Provider, {
      value: {
        state,
        dispatch
      }
    }, children || null);
  };
  StateProvider.displayName = "StateProvider";
  return StateProvider;
};
var useProvidedState = function () {
  var _a = React22.useContext(Context),
    state = _a.state,
    dispatch = _a.dispatch;
  return [state, dispatch];
};

// ../util/src/contact-us-widget/state-provider/contact-us-view-state/constants.ts
var ContactUsStateEvent2 = /* @__PURE__ */(ContactUsStateEvent6 => {
  ContactUsStateEvent6["OPEN_WIDGET"] = "OPEN_WIDGET";
  ContactUsStateEvent6["CLOSE_WIDGET"] = "CLOSE_WIDGET";
  ContactUsStateEvent6["CHANGE_VIEW"] = "CHANGE_VIEW";
  ContactUsStateEvent6["SIGNIN_REDIRECT"] = "SIGNIN_REDIRECT";
  return ContactUsStateEvent6;
})(ContactUsStateEvent2 || {});

// ../util/src/contact-us-widget/state-provider/contact-us-view-state/contact-us-state.ts
var ContactUsState = /*#__PURE__*/function () {
  function ContactUsState() {
    _classCallCheck(this, ContactUsState);
    this.stateFieldName = "contactUsState";
    this.data = {
      view: "LANDING_PAGE" /* LANDING_PAGE */,
      shouldWidgetBeVisible: false
    };
    this.events = Object.values(ContactUsStateEvent2);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return _createClass(ContactUsState, [{
    key: "update",
    value: function update(event, currentState, payload) {
      var _a;
      if (((_a = payload.data) == null ? void 0 : _a.view) === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ || currentState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && event === "CLOSE_WIDGET" /* CLOSE_WIDGET */) {
        localStorage.setItem("contactUsView", "VIRTUAL_AGENT" /* VIRTUAL_AGENT */);
      } else {
        localStorage.removeItem("contactUsView");
      }
      switch (event) {
        case "OPEN_WIDGET" /* OPEN_WIDGET */:
          return {
            view: payload.data.view,
            shouldWidgetBeVisible: true
          };
        case "CLOSE_WIDGET" /* CLOSE_WIDGET */:
          return {
            view: (payload == null ? void 0 : payload.data.view) || currentState.view,
            shouldWidgetBeVisible: false
          };
        case "CHANGE_VIEW" /* CHANGE_VIEW */:
          return {
            view: payload.data.view,
            shouldWidgetBeVisible: true
          };
        case "SIGNIN_REDIRECT" /* SIGNIN_REDIRECT */:
          localStorage.setItem("shouldOpenWidget", "true");
          localStorage.setItem("contactUsView", payload.data.view);
          return {
            view: currentState.view,
            shouldWidgetBeVisible: currentState.shouldWidgetBeVisible
          };
        default:
          return currentState;
      }
    }
  }]);
}();

// ../util/src/contact-us-widget/state-provider/contact-us-state-provider.tsx
var ContactUsStateProvider = buildStateProvider(new ContactUsState());

// ../util/src/contact-us-widget/hooks/use-contact-us-state.tsx
import React24 from "react";
function useContactUsState2() {
  const [state, dispatch] = useProvidedState();
  const {
    contactUsState
  } = state;
  const contactUsStateDispatch = React24.useCallback(({
    type,
    payload
  }) => {
    const contactUsStateAction = {
      type,
      payload: __spreadValues({}, payload)
    };
    dispatch(contactUsStateAction);
  }, [dispatch]);
  return [contactUsState, contactUsStateDispatch];
}

// ../util/src/virtual-agent/context.tsx
var defaultContextValue = {
  config: {
    eventHandler: () => console.error("Help Center VA Context Util not yet initialized")
  },
  controller: {
    sendMessage: () => console.error("Help Center VA Context Util not yet initialized")
  }
};
var VirtualAgentContext = createContext8(defaultContextValue);

// ../util/src/virtual-agent/mock-context.tsx
import React26, { useMemo as useMemo3 } from "react";

// ../internal/src/components/egds-text/egds-inline-link-control.tsx
var EGDSInlineLinkControl = ({
  data,
  inline
}) => {
  const {
    setArticleIdentifier,
    articleIdentifier,
    contactUsDialogActions,
    articleDialogActions
  } = useArticle();
  const {
    callerContext
  } = useCallerContext();
  const isArticle = data.action.resource.value.includes("#/link") || data.action.resource.value.includes("#/article") && !data.action.resource.value.includes("taapacademy.expediapartnersolutions.com");
  const isContactUs = data.action.resource.value.includes("contact-us");
  const isNewContactUsExperience = useExperiment("Contact_Us_Redesign_MVP_BEX_HCOM").exposure.bucket === 1;
  const [, contactUsStateDispatch] = useContactUsState2();
  const onClick = useCallback4((articleIdInfo, articleLink) => {
    setArticleIdentifier({
      articleLink,
      articleIdentifier: __spreadProps(__spreadValues({}, articleIdentifier), {
        articleId: articleIdInfo
      })
    });
  }, [articleIdentifier, setArticleIdentifier]);
  const track = useEgClickstream();
  const onClickCapture = (articleLinkType, searchTerm) => {
    const articleGroup = getArticleGroup({
      product: articleIdentifier.product,
      searchTerm: articleIdentifier.searchTerm
    });
    track(buildClickstreamAnalyticsForExternalArticles(data.action.resource.value, articleLinkType, data.text, articleGroup, searchTerm));
  };
  if (isArticle) {
    const articleIdInfo = data.action.resource.value.substr(data.action.resource.value.lastIndexOf("/") + 1);
    return /* @__PURE__ */React27.createElement(EGDSLink, {
      inline,
      key: data.text
    }, /* @__PURE__ */React27.createElement("button", {
      type: "button",
      onClick: () => onClick(articleIdInfo, data.action.resource.value)
    }, data.text));
  }
  if (isContactUs) {
    return /* @__PURE__ */React27.createElement(EGDSLink, {
      inline,
      key: data.text
    }, /* @__PURE__ */React27.createElement("button", {
      type: "button",
      onClick: () => {
        if (isNewContactUsExperience) {
          contactUsStateDispatch({
            type: "OPEN_WIDGET" /* OPEN_WIDGET */,
            payload: {
              view: "LANDING_PAGE" /* LANDING_PAGE */
            }
          });
        } else {
          articleDialogActions.closeDialog();
          setTimeout(() => contactUsDialogActions.openDialog(), 100);
        }
      },
      onClickCapture: () => onClickCapture(CONTACT_US_ARTICLE_LINK_TYPE, articleIdentifier.searchTerm)
    }, data.text));
  }
  return /* @__PURE__ */React27.createElement(EGDSLink, {
    inline,
    key: data.text
  }, /* @__PURE__ */React27.createElement("a", {
    href: data.action.resource.value,
    rel: "noopener",
    key: data.action.resource.value,
    onClickCapture: () => onClickCapture(data.action.target.valueOf(), articleIdentifier.searchTerm),
    target: callerContext === 1 /* QnA */ ? "_blank" : "_self"
  }, data.text));
};
EGDSInlineLinkControl.displayName = "EGDSInlineLinkControl";

// ../internal/src/components/egds-text/egds-inline-link-variant.tsx
import React28 from "react";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
var EGDSInlineLinkVariant = ({
  data,
  inline,
  onLinkClickHandler
}) => {
  const onLinkClick = event => {
    if (onLinkClickHandler && typeof onLinkClickHandler === "function") {
      onLinkClickHandler(event);
    }
  };
  return /* @__PURE__ */React28.createElement(EGDSLink2, {
    inline,
    key: data.text
  }, /* @__PURE__ */React28.createElement("a", {
    href: data.action.resource.value,
    rel: "noopener",
    key: data.action.resource.value,
    onClick: onLinkClick,
    target: data.action.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self"
  }, data.text));
};
EGDSInlineLinkVariant.displayName = "EGDSInlineLinkVariant";

// ../internal/src/components/egds-text/egds-inline-link.tsx
var fragment6 = gql9`
  fragment EGDSInlineLinkFragment on EGDSInlineLink {
    text
    action {
      target
      resource {
        value
      }
      accessibility
    }
  }
`;
var EGDSInlineLink = ({
  data,
  inline,
  onLinkClickHandler
}) => {
  return /* @__PURE__ */React29.createElement(Experiment, {
    name: "HELPCENTER_ARTICLE_LINK_FIX"
  }, /* @__PURE__ */React29.createElement(ExperimentControl, null, /* @__PURE__ */React29.createElement(EGDSInlineLinkControl, __spreadValues({}, {
    data,
    inline
  }))), /* @__PURE__ */React29.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React29.createElement(EGDSInlineLinkVariant, __spreadValues({}, {
    data,
    inline,
    onLinkClickHandler
  }))));
};
EGDSInlineLink.fragment = fragment6;
EGDSInlineLink.displayName = "EGDSInlineLink";

// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React30 from "react";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";
var fragment7 = gql10`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    text
    weight
  }
`;
var EGDSTextWeightMap = Object.freeze({
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
});
var EGDSStylizedText = ({
  data,
  inline
}) => /* @__PURE__ */React30.createElement(EGDSText2, {
  weight: data.weight ? EGDSTextWeightMap[data.weight] : void 0,
  inline,
  spacing: "two"
}, data.text);
EGDSStylizedText.fragment = fragment7;
EGDSStylizedText.displayName = "EGDSStylizedText";

// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment8 = gql11`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    contents {
      ...EGDSPlainTextFragment
      ...EGDSStylizedTextFragment
      ...EGDSInlineLinkFragment
    }
  }
  ${EGDSPlainText.fragment}
  ${EGDSStylizedText.fragment}
  ${EGDSInlineLink.fragment}
`;
var SpannableTextComponentMap = {
  EGDSPlainText,
  EGDSStylizedText,
  EGDSInlineLink
};
var SpannableTextComponentStyleMap = {
  EGDSPlainText: {
    inline: true
  },
  EGDSStylizedText: {
    inline: true
  },
  EGDSInlineLink: {
    inline: true
  }
};
var EGDSSpannableText = ({
  data,
  onLinkClickHandler
}) => {
  var _a;
  return /* @__PURE__ */React31.createElement(EGDSParagraph2, null, /* @__PURE__ */React31.createElement("span", null, (_a = data.contents) == null ? void 0 : _a.map((element, index) => {
    const SpannableTextComponent = SpannableTextComponentMap[element.__typename];
    if (!SpannableTextComponent) {
      return null;
    }
    if (element.__typename === "EGDSInlineLink") {
      return /* @__PURE__ */React31.createElement(SpannableTextComponent, __spreadValues(__spreadValues({
        data: element,
        key: index
      }, SpannableTextComponentStyleMap[element.__typename]), {
        onLinkClickHandler
      }));
    }
    return /* @__PURE__ */React31.createElement(SpannableTextComponent, __spreadValues({
      data: element,
      key: index
    }, SpannableTextComponentStyleMap[element.__typename]));
  })));
};
EGDSSpannableText.fragment = fragment8;
EGDSSpannableText.displayName = "EGDSSpannableText";

// ../internal/src/components/egds-text/egds-text.tsx
var fragment9 = gql12`
  fragment EGDSTextFragment on EGDSText {
    ...EGDSHeadingFragment
    ...EGDSParagraphFragment
    ...EGDSSpannableTextFragment
    ...EGDSPlainTextFragment
  }
  ${HelpCenterEGDSParagraph.fragment}
  ${EGDSPlainText.fragment}
  ${HelpCenterEGDSHeading.fragment}
  ${EGDSSpannableText.fragment}
`;
var TextComponentMap = {
  EGDSParagraph: HelpCenterEGDSParagraph,
  EGDSHeading: HelpCenterEGDSHeading,
  EGDSSpannableText,
  EGDSPlainText
};
var HelpCenterEGDSText = ({
  data,
  align
}) => {
  const TextComponent = TextComponentMap[data.__typename];
  if (!TextComponent) {
    return null;
  }
  return /* @__PURE__ */React32.createElement(TextComponent, {
    align,
    data
  });
};
HelpCenterEGDSText.fragment = fragment9;
HelpCenterEGDSText.displayName = "HelpCenterEGDSText";

// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React33 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";
var fragment10 = gql13`
  fragment EGDSGraphicTextFragment on EGDSGraphicText {
    graphic {
      ...EGDSGraphicFragment
    }
    text
  }

  ${EGDSGraphic.fragment}
`;
var EGDSGraphicText = ({
  data,
  textSize,
  textWeight,
  textTheme,
  direction
}) => {
  const {
    graphic,
    text
  } = data;
  return /* @__PURE__ */React33.createElement(EGDSLayoutFlex, {
    direction
  }, /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React33.createElement(EGDSText3, {
    size: textSize,
    theme: textTheme,
    weight: textWeight
  }, text)), /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem, null, data.graphic && /* @__PURE__ */React33.createElement(EGDSGraphic, {
    data: data.graphic
  })));
};
EGDSGraphicText.fragment = fragment10;
EGDSGraphicText.displayName = "EGDSGraphicText";

// src/components/contact-us-view/components/contact-us-heading.tsx
var fragment11 = gql14`
  fragment ContactUsHeadingFragment on ContactUsHeading {
    __typename
    text {
      __typename
      ...EGDSHeadingFragment
    }
  }
  ${HelpCenterEGDSHeading.fragment}
`;
var ContactUsHeading = ({
  data,
  headingSize,
  spacingNeeded,
  margin
}) => {
  return /* @__PURE__ */React34.createElement(EGDSSpacing2, {
    margin: {
      blockstart: spacingNeeded ? "six" : "unset"
    }
  }, /* @__PURE__ */React34.createElement("div", {
    "data-stid": "help-center-contact-us-heading"
  }, data.text.__typename === "EGDSHeading" && /* @__PURE__ */React34.createElement(HelpCenterEGDSHeading, {
    data: {
      __typename: data.text.__typename,
      text: data.text.text,
      headingType: headingSize
    },
    margin
  })));
};
ContactUsHeading.fragment = fragment11;
ContactUsHeading.displayName = "ContactUsHeading";

// src/components/contact-us-view/components/contact-us-paragraph.tsx
import React35 from "react";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";
var fragment12 = gql15`
  fragment ContactUsParagraphFragment on ContactUsParagraph {
    __typename
    text {
      ...EGDSParagraphFragment
    }
  }
  ${HelpCenterEGDSParagraph.fragment}
`;
var ContactUsParagraph = ({
  data,
  paragraphSize,
  spacingNeeded
}) => {
  return /* @__PURE__ */React35.createElement(EGDSSpacing3, {
    margin: {
      blockstart: spacingNeeded ? "two" : "unset"
    }
  }, /* @__PURE__ */React35.createElement("div", {
    "data-stid": "help-center-contact-us-paragraph"
  }, data.text.__typename === "EGDSParagraph" && /* @__PURE__ */React35.createElement(HelpCenterEGDSParagraph, {
    data: {
      __typename: data.text.__typename,
      text: data.text.text,
      style: paragraphSize
    }
  })));
};
ContactUsParagraph.fragment = fragment12;
ContactUsParagraph.displayName = "ContactUsParagraph";

// src/components/contact-us-view/components/contact-us-card.tsx
import React36 from "react";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { gql as gql17 } from "@shared-ui/apollo-client-wrapper";
import { ContactUsStateEvent as ContactUsStateEvent3, ContactUsViewType as ContactUsViewType4, useContactUsState as useContactUsState3, useVirtualAgentContext as useVirtualAgentContext2 } from "@shared-ui/retail-help-center-util";

// src/components/contact-us-view/analytics/helper.ts
var buildWorkFlowList = (contactUsClickStreamAnalytics, intentSelected, productSelected) => {
  var _a, _b;
  if (contactUsClickStreamAnalytics.contactUsWorkFlow) {
    const workflow = {
      viewType: (_a = contactUsClickStreamAnalytics.contactUsWorkFlow.viewType) != null ? _a : "LANDING_PAGE" /* LANDING_PAGE */,
      channelType: (_b = contactUsClickStreamAnalytics.contactUsWorkFlow.channelType) != null ? _b : "",
      productSelected: productSelected != null ? productSelected : "",
      intentSelected: intentSelected != null ? intentSelected : ""
    };
    return {
      work_flow: workflow
    };
  }
  return {};
};
var buildClickStreamForContactUs = (contactUsClickStreamAnalytics, intentSelected, productSelected) => {
  const contactUsWorkFlow = buildWorkFlowList(contactUsClickStreamAnalytics, intentSelected, productSelected);
  return __spreadValues({
    event: {
      event_name: contactUsClickStreamAnalytics.event.eventName,
      event_version: contactUsClickStreamAnalytics.event.eventVersion,
      event_type: contactUsClickStreamAnalytics.event.eventType
    },
    experience: {
      page_name: contactUsClickStreamAnalytics.experience.pageName,
      app_name: contactUsClickStreamAnalytics.experience.appName,
      app_version: contactUsClickStreamAnalytics.experience.appVersion
    }
  }, contactUsWorkFlow);
};

// src/components/contact-us-view/components/contact-us-click-stream.tsx
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";
var ContactUsClickStreamFragment2 = gql16`
  fragment ContactUsClickStreamFragment on ContactUsClickStreamAnalytics {
    event {
      eventName
      eventType
      eventVersion
      __typename
    }
    __typename
    experience {
      appName
      appVersion
      pageName
      __typename
    }
    contactUsWorkFlow {
      __typename
      viewType
      channelType
      productSelected
      intentSelected
    }
  }
`;

// src/components/contact-us-view/components/contact-us-card.tsx
var fragment13 = gql17`
  fragment ContactUsCardFragment on ContactUsCard {
    __typename
    icon {
      ...EGDSIconFragment
    }
    heading {
      ...ContactUsHeadingFragment
    }
    subheading {
      ...ContactUsParagraphFragment
    }
    intentPayload {
      payload
      skillName
      vaText
    }
    cardClickStreamAnalytics {
      ...ContactUsClickStreamFragment
    }
  }
  ${ContactUsClickStreamFragment2}
  ${HelpCenterEGDSIcon.fragment}
  ${ContactUsHeading.fragment}
  ${ContactUsParagraph.fragment}
`;
var ContactUsCard = ({
  data
}) => {
  const {
    controller
  } = useVirtualAgentContext2();
  const [contactUsState, contactUsStateDispatch] = useContactUsState3();
  const invokeVaWithIntent = intentPayload => {
    const message = {
      text: intentPayload.vaText,
      messageType: "POSTBACK",
      intent: intentPayload.skillName
    };
    if (intentPayload == null ? void 0 : intentPayload.payload) {
      message.payload = intentPayload.payload;
      controller.sendMessage(message);
    }
    contactUsStateDispatch({
      type: ContactUsStateEvent3.CHANGE_VIEW,
      payload: {
        view: ContactUsViewType4.VIRTUAL_AGENT
      }
    });
  };
  const handleClick = () => {
    var _a;
    if (data == null ? void 0 : data.cardClickStreamAnalytics) {
      buildClickStreamForContactUs(data == null ? void 0 : data.cardClickStreamAnalytics);
    }
    if (data == null ? void 0 : data.intentPayload) {
      invokeVaWithIntent(data == null ? void 0 : data.intentPayload);
    } else if (contactUsState.view === ContactUsViewType4.CONTACT_OPTIONS && ((_a = data.icon) == null ? void 0 : _a.id) === "chat") {
      contactUsStateDispatch({
        type: ContactUsStateEvent3.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType4.CHAT_OPTIONS
        }
      });
    } else if (contactUsState.view === ContactUsViewType4.CONTACT_OPTIONS) {
      contactUsStateDispatch({
        type: ContactUsStateEvent3.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType4.VOICE_OPTIONS
        }
      });
    }
  };
  return /* @__PURE__ */React36.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React36.createElement(EGDSCard, {
    padded: true,
    border: true,
    "data-stid": "help-center-contact-us-card",
    onClick: () => handleClick()
  }, /* @__PURE__ */React36.createElement(EGDSLayoutFlex2, {
    direction: "row",
    alignItems: "center"
  }, data.icon && /* @__PURE__ */React36.createElement(HelpCenterEGDSIcon, {
    data: {
      id: data.icon.id,
      description: data.icon.description,
      __typename: data.icon.__typename,
      theme: null,
      spotLight: null,
      size: null,
      title: null
    }
  }), /* @__PURE__ */React36.createElement(EGDSSpacing4, {
    padding: {
      inlinestart: "three"
    }
  }, /* @__PURE__ */React36.createElement(EGDSCardContentSection, {
    padded: false
  }, data.heading && /* @__PURE__ */React36.createElement(ContactUsHeading, {
    data: data.heading,
    headingSize: "H4" /* H4 */,
    spacingNeeded: false,
    margin: data.subheading ? {
      blockstart: "two"
    } : "unset"
  }), data.subheading && /* @__PURE__ */React36.createElement(ContactUsParagraph, {
    data: data.subheading,
    paragraphSize: "P3" /* P3 */,
    spacingNeeded: true
  }))))));
};
ContactUsCard.fragment = fragment13;
ContactUsCard.displayName = "ContactUsCard";

// src/components/contact-us-view/components/contact-us-button.tsx
import React37 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { gql as gql18 } from "@shared-ui/apollo-client-wrapper";
import { ContactUsStateEvent as ContactUsStateEvent4, ContactUsViewType as ContactUsViewType5, useContactUsState as useContactUsState4 } from "@shared-ui/retail-help-center-util";
var fragment14 = gql18`
  fragment ContactUsButtonFragment on ContactUsButton {
    __typename
    button {
      ...EGDSButtonFragment
    }
    buttonClickStreamAnalytics {
      ...ContactUsClickStreamFragment
    }
  }
  ${HelpCenterEGDSButton.fragment}
  ${ContactUsClickStreamFragment2}
`;
var ContactUsButton = ({
  data,
  payload,
  setQueryPayload,
  setPayload,
  onClickOverride,
  isSignInButton,
  isErrorView
}) => {
  const [contactUsState, contactUsStateDispatch] = useContactUsState4();
  let justify = "flex-end";
  if (isErrorView) {
    justify = "center";
  } else if (isSignInButton) {
    justify = "flex-start";
  }
  const size = isSignInButton ? EGDSButtonSize.SMALL : EGDSButtonSize.LARGE;
  const widthStyle = isErrorView ? void 0 : {
    width: isSignInButton ? "70px" : "160px"
  };
  const disableButton = payload ? !payload.intentSelected || !payload.productSelected : false;
  const handleClick = () => {
    if (data == null ? void 0 : data.buttonClickStreamAnalytics) {
      buildClickStreamForContactUs(data == null ? void 0 : data.buttonClickStreamAnalytics, "", "");
    }
    if (isErrorView) {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType5.LANDING_PAGE
        }
      });
      return;
    }
    if (onClickOverride) {
      onClickOverride();
      return;
    }
    if (contactUsState.view === ContactUsViewType5.LANDING_PAGE) {
      if (setQueryPayload && payload) {
        setQueryPayload(payload);
      }
      contactUsStateDispatch({
        type: ContactUsStateEvent4.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType5.CONTACT_OPTIONS
        }
      });
    } else if (contactUsState.view === ContactUsViewType5.CONTACT_OPTIONS) {
      if (setPayload && payload && setQueryPayload) {
        setPayload({
          intentSelected: "",
          productSelected: "",
          viewType: contactUsState.view
        });
        setQueryPayload({
          intentSelected: "",
          productSelected: "",
          viewType: contactUsState.view
        });
      }
      contactUsStateDispatch({
        type: ContactUsStateEvent4.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType5.LANDING_PAGE
        }
      });
    } else if (contactUsState.view === ContactUsViewType5.VOICE_OPTIONS) {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType5.CONTACT_OPTIONS
        }
      });
    } else if (contactUsState.view === ContactUsViewType5.CHAT_OPTIONS) {
      contactUsStateDispatch({
        type: ContactUsStateEvent4.CHANGE_VIEW,
        payload: {
          view: ContactUsViewType5.CONTACT_OPTIONS
        }
      });
    }
  };
  return /* @__PURE__ */React37.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React37.createElement("div", {
    "data-stid": "help-center-contact-us-button",
    style: {
      display: "flex",
      justifyContent: justify
    }
  }, /* @__PURE__ */React37.createElement(HelpCenterEGDSButton, {
    data: __spreadProps(__spreadValues({}, data.button), {
      icon: null
    }),
    size,
    style: widthStyle,
    isFullWidth: isErrorView,
    onClickHandler: handleClick,
    isDisabled: disableButton
  })));
};
ContactUsButton.fragment = fragment14;
ContactUsButton.displayName = "ContactUsButton";

// src/components/contact-us-view/components/contact-us-phone-number.tsx
import React38 from "react";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { gql as gql19 } from "@shared-ui/apollo-client-wrapper";
var fragment15 = gql19`
  fragment ContactUsPhoneNumberFragment on ContactUsPhoneNumber {
    __typename
    label {
      text {
        ...EGDSParagraphFragment
      }
    }
    phoneNumber {
      text {
        ...EGDSParagraphFragment
      }
    }
  }
  ${HelpCenterEGDSParagraph.fragment}
`;
var ContactUsPhoneNumber = ({
  data
}) => {
  var _a, _b;
  const isEGDSParagraph = item => (item == null ? void 0 : item.__typename) === "EGDSParagraph";
  return /* @__PURE__ */React38.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React38.createElement(EGDSCard2, {
    padded: true,
    "data-stid": "help-center-contact-phone-number",
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React38.createElement(EGDSCardContentSection2, {
    padded: false
  }, /* @__PURE__ */React38.createElement(EGDSSpacing6, {
    margin: {
      inlineend: "two"
    }
  }, isEGDSParagraph((_a = data.phoneNumber) == null ? void 0 : _a.text) && /* @__PURE__ */React38.createElement(EGDSText4, {
    align: "left",
    hyphens: "none",
    overflow: "wrap",
    spacing: "one",
    theme: "standard",
    whiteSpace: "normal",
    inline: true,
    typeStyle: {
      customStyle: "text-large",
      customTheme: "standard"
    }
  }, data.phoneNumber.text.text)), /* @__PURE__ */React38.createElement(EGDSSpacing6, null, isEGDSParagraph((_b = data.label) == null ? void 0 : _b.text) && /* @__PURE__ */React38.createElement(EGDSText4, {
    align: "left",
    hyphens: "none",
    overflow: "wrap",
    spacing: "one",
    theme: "secondary",
    whiteSpace: "normal",
    inline: true,
    typeStyle: {
      customStyle: "text-small",
      customTheme: "standard"
    }
  }, data.label.text.text)))));
};
ContactUsPhoneNumber.fragment = fragment15;
ContactUsPhoneNumber.displayName = "ContactUsPhoneNumber";

// src/components/contact-us-view/components/contact-us-error-view.tsx
import React39 from "react";
import { EGDSIcon as EGDSIcon2, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText5 } from "@egds/react-core/text";
import { gql as gql20 } from "@shared-ui/apollo-client-wrapper";
var fragment16 = gql20`
  fragment ContactUsErrorViewFragment on ContactUsErrorViewV2 {
    __typename
    errorIcon {
      ...EGDSIconFragment
    }
    errorRetryButton {
      ...ContactUsButtonFragment
    }
    title {
      text {
        ...EGDSHeadingFragment
      }
    }
    message {
      text {
        ...EGDSParagraphFragment
      }
    }
  }
  ${HelpCenterEGDSIcon.fragment}
  ${ContactUsButton.fragment}
  ${HelpCenterEGDSHeading.fragment}
  ${HelpCenterEGDSParagraph.fragment}
`;
var ContactUsErrorView = ({
  data
}) => {
  var _a, _b, _c;
  const isEGDSHeading = item => (item == null ? void 0 : item.__typename) === "EGDSHeading";
  const isEGDSParagraph = item => (item == null ? void 0 : item.__typename) === "EGDSParagraph";
  return /* @__PURE__ */React39.createElement(React39.Fragment, null, /* @__PURE__ */React39.createElement(EGDSSpacing7, {
    margin: {
      blockstart: "sixteen"
    }
  }, /* @__PURE__ */React39.createElement(EGDSLayoutFlex3, {
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem2, null, (data == null ? void 0 : data.errorIcon) && /* @__PURE__ */React39.createElement(EGDSIcon2, {
    id: data.errorIcon.id,
    name: data.errorIcon.id,
    size: EGDSIconSize2.XLARGE,
    title: (_a = data == null ? void 0 : data.errorIcon.title) != null ? _a : void 0,
    spotlight: "warning"
  })), /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem2, null, isEGDSHeading((_b = data == null ? void 0 : data.title) == null ? void 0 : _b.text) && /* @__PURE__ */React39.createElement(EGDSHeading2, {
    align: "center"
  }, data.title.text.text)), /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem2, null, isEGDSParagraph((_c = data == null ? void 0 : data.message) == null ? void 0 : _c.text) && /* @__PURE__ */React39.createElement(EGDSText5, {
    align: "center",
    theme: "standard",
    whiteSpace: "normal"
  }, data.message.text.text)))), (data == null ? void 0 : data.errorRetryButton) && /* @__PURE__ */React39.createElement(ContactUsButton, {
    data: data.errorRetryButton,
    isErrorView: true
  }));
};
ContactUsErrorView.fragment = fragment16;
ContactUsErrorView.displayName = "ContactUsErrorView";

// src/components/contact-us-view/components/contact-us-menu.tsx
import React42 from "react";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { gql as gql23 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-select/egds-select.tsx
import React41 from "react";
import { EGDSSelect } from "@egds/react-core/input";
import { gql as gql22 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-select/egds-basic-option.tsx
import React40 from "react";
import { gql as gql21 } from "@shared-ui/apollo-client-wrapper";
var __Fragment = gql21`
  fragment EGDSBasicOptionFragment on EGDSBasicOption {
    value
    selected
    label
  }
`;
var EGDSBasicOption = ({
  data
}) => {
  var _a;
  return /* @__PURE__ */React40.createElement("option", {
    key: data.value,
    value: data.value,
    "aria-selected": (_a = data.selected) != null ? _a : false
  }, data.label);
};
EGDSBasicOption.displayName = "EGDSBasicOption";
EGDSBasicOption.fragment = __Fragment;

// ../internal/src/components/egds-select/egds-select.tsx
var __Fragment2 = gql22`
  fragment EGDSSelectFragment on EGDSBasicSelect {
    options {
      ...EGDSBasicOptionFragment
    }
    label
    egdsElementId
    readOnly
  }
  ${EGDSBasicOption.fragment}
`;
var HelpCenterEGDSSelect = ({
  emptyState,
  value,
  onChange,
  data,
  required
}) => {
  const {
    label,
    egdsElementId,
    options,
    readOnly
  } = data;
  if (!egdsElementId || options.length === 0) {
    return null;
  }
  return /* @__PURE__ */React41.createElement(EGDSSelect, {
    readOnly,
    value,
    label,
    id: egdsElementId,
    onChange,
    emptyState,
    required
  }, options.map((optionItem, index) => optionItem.__typename === "EGDSBasicOption" && /* @__PURE__ */React41.createElement(EGDSBasicOption, {
    key: `option-${index}`,
    data: optionItem
  })));
};
HelpCenterEGDSSelect.displayName = "HelpCenterEGDSSelect";
HelpCenterEGDSSelect.fragment = __Fragment2;

// src/components/contact-us-view/components/contact-us-menu.tsx
var fragment17 = gql23`
  fragment ContactUsMenuFragment on ContactUsMenu {
    __typename
    menu {
      ...EGDSSelectFragment
    }
  }
  ${HelpCenterEGDSSelect.fragment}
`;
var ContactUsMenu = ({
  data,
  payload,
  setPayload
}) => {
  const {
    egdsElementId,
    label,
    options,
    readOnly
  } = data.menu;
  const onChange = e => {
    const {
      id,
      value
    } = e.target;
    setPayload(prev => __spreadProps(__spreadValues({}, prev), {
      intentSelected: id === "intentSelect" ? value : prev.intentSelected,
      productSelected: id === "productSelect" ? value : prev.productSelected
    }));
  };
  let currentValue = egdsElementId === "intentSelect" ? payload.intentSelected : payload.productSelected;
  if (currentValue === void 0 || currentValue === null) {
    currentValue = "";
  }
  return /* @__PURE__ */React42.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React42.createElement("div", {
    "data-stid": "help-center-contact-us-menu"
  }, /* @__PURE__ */React42.createElement(HelpCenterEGDSSelect, {
    data: data.menu,
    value: currentValue,
    emptyState: true,
    onChange,
    required: true
  })));
};
ContactUsMenu.fragment = fragment17;
ContactUsMenu.displayName = "ContactUsMenu";

// src/components/contact-us-view/components/contact-us-sign-in-card.tsx
import React43 from "react";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { gql as gql24 } from "@shared-ui/apollo-client-wrapper";
var fragment18 = gql24`
  fragment ContactUsSignInCardFragment on ContactUsSignInCard {
    __typename
    signInSubheading: subheading {
      ...ContactUsParagraphFragment
    }
    signInButton {
      ...ContactUsButtonFragment
      button {
        __typename
        primary
        action {
          __typename
          ... on UILinkAction {
            resource {
              __typename
              value
            }
            accessibility
          }
        }
      }
    }
  }
  ${ContactUsParagraph.fragment}
  ${ContactUsButton.fragment}
`;
var ContactUsSignInCard = ({
  data
}) => {
  var _a;
  const {
    signInSubheading,
    signInButton
  } = data;
  const href = ((_a = signInButton.button.action) == null ? void 0 : _a.__typename) === "UILinkAction" ? signInButton.button.action.resource.value : void 0;
  const handleSignIn = () => {
    if (href) {
      window.location.href = href;
    }
  };
  return /* @__PURE__ */React43.createElement(EGDSSpacing9, {
    margin: {
      blockstart: "four",
      blockend: "six"
    }
  }, /* @__PURE__ */React43.createElement("div", {
    "data-stid": "help-center-contact-us-sign-in-card",
    style: {
      borderRadius: "8px",
      padding: "16px",
      background: "#EFF3F7"
    }
  }, /* @__PURE__ */React43.createElement(ContactUsParagraph, {
    data: signInSubheading,
    paragraphSize: "P2" /* P2 */,
    spacingNeeded: false
  }), /* @__PURE__ */React43.createElement(ContactUsButton, {
    data: data.signInButton,
    isSignInButton: true,
    onClickOverride: handleSignIn
  })));
};
ContactUsSignInCard.fragment = fragment18;
ContactUsSignInCard.displayName = "ContactUsSignInCard";

// src/components/contact-us-view/contact-us-view.tsx
var __Query = gql25`
  query ContactUsInfo($context: ContextInput!, $requestPayload: ContactUsPayloadInput!) {
    contactUsInfo(context: $context, requestPayload: $requestPayload) {
      contactUsByViewType {
        ...ContactUsHeadingFragment
        ...ContactUsParagraphFragment
        ...ContactUsCardFragment
        ...ContactUsButtonFragment
        ...ContactUsPhoneNumberFragment
        ...ContactUsClickStreamFragment
        ...ContactUsErrorViewFragment
        ...ContactUsMenuFragment
        ...ContactUsSignInCardFragment
      }
    }
  }
  ${ContactUsHeading.fragment}
  ${ContactUsParagraph.fragment}
  ${ContactUsCard.fragment}
  ${ContactUsButton.fragment}
  ${ContactUsPhoneNumber.fragment}
  ${ContactUsClickStreamFragment2}
  ${ContactUsErrorView.fragment}
  ${ContactUsMenu.fragment}
  ${ContactUsSignInCard.fragment}
`;
var ContactUsViewContent = ({
  skipSsr = false,
  requestPayload = {
    intentSelected: "",
    productSelected: "",
    viewType: "LANDING_PAGE" /* LANDING_PAGE */
  }
}) => {
  var _a, _b;
  const {
    context
  } = useBexApi();
  const {
    intentSelected,
    productSelected,
    viewType
  } = requestPayload;
  const [payload, setPayload] = useState3(requestPayload);
  const [queryPayload, setQueryPayload] = useState3(requestPayload);
  const variables = {
    context,
    requestPayload: {
      intentSelected: queryPayload.intentSelected,
      productSelected: queryPayload.productSelected,
      viewType
    }
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    ssr: !skipSsr,
    variables,
    fetchPolicy: "network-only"
  });
  if (loading || error || !data) {
    return null;
  }
  return (_b = (_a = data == null ? void 0 : data.contactUsInfo) == null ? void 0 : _a.contactUsByViewType) == null ? void 0 : _b.map(ele => {
    switch (ele == null ? void 0 : ele.__typename) {
      case "ContactUsHeading":
        return /* @__PURE__ */React44.createElement(ContactUsHeading, {
          data: ele,
          key: "heading",
          headingSize: "H3" /* H3 */,
          spacingNeeded: true
        });
      case "ContactUsParagraph":
        return /* @__PURE__ */React44.createElement(ContactUsParagraph, {
          data: ele,
          key: "paragraph",
          paragraphSize: "P2" /* P2 */,
          spacingNeeded: true
        });
      case "ContactUsCard":
        return /* @__PURE__ */React44.createElement(ContactUsCard, {
          data: ele,
          key: "card"
        });
      case "ContactUsMenu":
        return /* @__PURE__ */React44.createElement(ContactUsMenu, {
          data: ele,
          key: ele.menu.egdsElementId,
          payload,
          setPayload
        });
      case "ContactUsButton":
        return /* @__PURE__ */React44.createElement(ContactUsButton, {
          data: ele,
          key: "button",
          payload,
          setQueryPayload,
          setPayload
        });
      case "ContactUsPhoneNumber":
        return /* @__PURE__ */React44.createElement(ContactUsPhoneNumber, {
          data: ele,
          key: "phone-number"
        });
      case "ContactUsSignInCard":
        return /* @__PURE__ */React44.createElement(ContactUsSignInCard, {
          data: ele,
          key: "signInCard"
        });
      case "ContactUsClickStreamAnalytics":
        buildClickStreamForContactUs(ele, "", "");
        return null;
      // or some other component if you want to display something for clickstream
      case "ContactUsErrorViewV2":
        return /* @__PURE__ */React44.createElement(ContactUsErrorView, {
          data: ele,
          key: "error-view"
        });
      default:
        return null;
    }
  });
};
ContactUsViewContent.displayName = "sharedui-ContactUsView";

// src/components/contact-us-widget/contact-us.tsx
var __Query2 = gql26`
  query ContactUsInitializeContent($context: ContextInput!) {
    contactUsInfo(context: $context) {
      contactUsInitializeContent {
        ... on ContactUsInitialization {
          contactUsFloatingActionButton {
            floatingActionButton {
              ...FloatingActionButtonFragment
            }
          }
          contactUsToolBar {
            ...ContactUsToolBarFragmentV2
          }
        }
      }
    }
  }
  ${FloatingActionButton.fragment}
  ${ContactUsToolBarV2.fragment}
`;
var vacEvents = {
  vacConversationCreatedEvent: "VAC_ConversationCreated",
  vacConversationJoinedEvent: "VAC_ConversationJoined",
  vacInitializedEvent: "VAC_Initialized",
  vacLazyInitializedEvent: "VAC_LazyInitializeFailed",
  vacCreateFrameFailedEvent: "VAC_CreateFrameFailed",
  vacStartFrameFailedEvent: "VAC_StartFrameFailed",
  vacConversationCreateFailedEvent: "VAC_ConversationCreateFailed",
  vacConversationJoinFailedEvent: "VAC_ConversationJoinFailed",
  vacFabPresented: "VAC_FabPresented"
};
var ContactUs = ({
  skipSsr,
  vacProps,
  handleEvents,
  intentMessage,
  isComponentTest
}) => {
  var _a, _b, _c, _d, _e;
  const {
    context
  } = useBexApi2();
  const [contactUsState, contactUsStateDispatch] = useContactUsState5();
  const localStorageContactUsView = localStorage.getItem("contactUsView");
  const subscribedEvents = Object.values(vacEvents);
  const defaultPayload = {
    skipSsr,
    requestPayload: {
      viewType: contactUsState.view,
      intentSelected: "",
      productSelected: ""
    }
  };
  const variables = {
    context
  };
  React45.useEffect(() => {
    if (isComponentTest && !intentMessage) {
      contactUsStateDispatch({
        type: ContactUsStateEvent5.OPEN_WIDGET,
        payload: {
          view: "LANDING_PAGE" /* LANDING_PAGE */
        }
      });
    }
    if (intentMessage) {
      contactUsStateDispatch({
        type: ContactUsStateEvent5.OPEN_WIDGET,
        payload: {
          view: "LANDING_PAGE" /* LANDING_PAGE */
        }
      });
      setTimeout(() => {
        contactUsStateDispatch({
          type: ContactUsStateEvent5.CHANGE_VIEW,
          payload: {
            view: "VIRTUAL_AGENT" /* VIRTUAL_AGENT */
          }
        });
      }, 1e3);
    }
    if (localStorage.getItem("shouldOpenWidget") !== null) {
      contactUsStateDispatch({
        type: ContactUsStateEvent5.OPEN_WIDGET,
        payload: {
          view: localStorageContactUsView
        }
      });
      localStorage.removeItem("shouldOpenWidget");
      localStorage.removeItem("contactUsView");
    }
  }, []);
  const handleFabClick = () => {
    contactUsStateDispatch({
      type: ContactUsStateEvent5.OPEN_WIDGET,
      payload: {
        view: contactUsState.view
      }
    });
  };
  const virtualAgentControl = /* @__PURE__ */React45.createElement(VirtualAgentControl, {
    applicationName: "ecp-help-center",
    pageName: "ecp-help-center",
    clientOverrides: {
      subscribedEvents: [...subscribedEvents, ...REQUIRED_EVENT2],
      eventHandler: event => {
        handleEvents(event);
      },
      enableAutoOpenChatWidget: false,
      embedded: vacProps.embedded,
      containerElement: document.getElementById("vac-container"),
      configurationOverrides: {
        hideHeader: vacProps.hideHeader,
        hideAvatar: vacProps.hideAvatar,
        textInputPlaceHolder: vacProps.textInputPlaceHolder
      },
      intentMessage
    },
    inputs: {},
    skipSsr: true
  });
  const {
    data,
    error,
    loading
  } = useQuery2(__Query2, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr
  });
  const fab = (_a = data == null ? void 0 : data.contactUsInfo.contactUsInitializeContent) == null ? void 0 : _a.contactUsFloatingActionButton.floatingActionButton;
  const contactUsToolBar = (_b = data == null ? void 0 : data.contactUsInfo.contactUsInitializeContent) == null ? void 0 : _b.contactUsToolBar;
  if (loading || error || !data) {
    return null;
  }
  return /* @__PURE__ */React45.createElement(React45.Fragment, null, !contactUsState.shouldWidgetBeVisible && localStorageContactUsView === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && /* @__PURE__ */React45.createElement(FloatingActionButton, {
    onClick: () => handleFabClick(),
    data: fab
  }), /* @__PURE__ */React45.createElement(ChatContainer, {
    visible: contactUsState.shouldWidgetBeVisible,
    padded: true
  }, /* @__PURE__ */React45.createElement(ChatContainerHeader, null, /* @__PURE__ */React45.createElement(ContactUsToolBarV2, {
    data: contactUsToolBar
  })), /* @__PURE__ */React45.createElement(ChatContainerContent, null, contactUsState.view !== "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && /* @__PURE__ */React45.createElement(ContactUsViewContent, {
    inputs: {},
    requestPayload: {
      viewType: ((_c = defaultPayload.requestPayload) == null ? void 0 : _c.viewType) || "LANDING_PAGE" /* LANDING_PAGE */,
      intentSelected: (_d = defaultPayload.requestPayload) == null ? void 0 : _d.intentSelected,
      productSelected: (_e = defaultPayload.requestPayload) == null ? void 0 : _e.productSelected
    }
  }), /* @__PURE__ */React45.createElement("div", {
    role: "region",
    "aria-label": "Virtual agent",
    id: "vac-container",
    className: "hide-vac-false",
    "data-stid": "vacContainer",
    style: {
      height: "100%"
    }
  }, contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && contactUsState.shouldWidgetBeVisible && vacProps.vacState.isLoading && /* @__PURE__ */React45.createElement(CenteredLoader, null), contactUsState.view === "VIRTUAL_AGENT" /* VIRTUAL_AGENT */ && contactUsState.shouldWidgetBeVisible && virtualAgentControl))));
};
ContactUs.displayName = "sharedui-ContactUs";
export { ContactUs, ContactUsViewType2 as ContactUsViewType };
/* istanbul ignore file -- @preserve */
//# sourceMappingURL=index.js.map